import * as React from 'react';

import { type IconProp } from '@fortawesome/fontawesome-svg-core';
import { faClockRotateLeft } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { type VariantProps } from 'class-variance-authority';

import { GeneralBlock, GeneralBlockTitle, GeneralBlockValue } from 'src/registry/components/blocks/GeneralBlock';
import { Badge, badgeVariants } from 'src/registry/ui/Badge';

interface DashboardBlockProps extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof badgeVariants> {
    value: any;
    label?: string;
    icon?: IconProp;
    badgeComponent?: React.ReactNode;
}

function DashboardMetric({
    title,
    className,
    value,
    badgeComponent,
    theme,
    variant,
    icon,
    label,
}: DashboardBlockProps) {
    return (
        <GeneralBlock className={className}>
            <GeneralBlockTitle className="flex justify-between">
                {title}
                <div className="flex items-center gap-1.5 text-sm text-gray-500">
                    <p>24h</p>
                    <FontAwesomeIcon className="opacity-70" icon={faClockRotateLeft} />
                </div>
            </GeneralBlockTitle>
            <GeneralBlockValue className="mb-8 lg:mb-0">{value}</GeneralBlockValue>

            <div className="absolute right-0 bottom-0 flex flex-wrap justify-end gap-2 self-end p-4">
                {!badgeComponent && (
                    <Badge variant={variant} theme={theme}>
                        {icon && <FontAwesomeIcon className="opacity-70" icon={icon} />}
                        {label}
                    </Badge>
                )}
                {badgeComponent}
            </div>
        </GeneralBlock>
    );
}

interface DashboardMetricPeriodIndicatorProps extends React.HTMLAttributes<HTMLDivElement> {}
const DashboardMetricPeriodIndicator = ({ children }: DashboardMetricPeriodIndicatorProps) => {
    return (
        <div className="flex items-center gap-1.5 text-sm text-gray-500">
            <p>{children}</p>
            <FontAwesomeIcon className="opacity-70" icon={faClockRotateLeft} />
        </div>
    );
};

interface DashboardMetricBadgesProps extends React.HTMLAttributes<HTMLDivElement> {}
const DashboardMetricBadges = ({ children }: DashboardMetricBadgesProps) => {
    return <div className="flex grow flex-wrap justify-end gap-2 self-end">{children}</div>;
};

export { DashboardMetric, DashboardMetricPeriodIndicator, DashboardMetricBadges };
